
export enum FuelType {

  Unknown = 0,
  Diesel = 1,
  CNGDiesel = 2,
  LNGDiesel = 3,
  ElectricDiesel = 4
  }